import L from 'leaflet';
import mapbase from './map_base';
import util from '../util';
;
/**
 * 雨量地図表示用クラス
 */
export default class map_uryo extends mapbase {
    /**
     * コンストラクタ
     */
    constructor(mapElement, mapPos, isSp) {
        super(mapElement, mapPos);
        this._uryoLayer = null;
        this._preSelect = null;
        map_uryo._isSp = isSp;
        this.checkUpdateLayer();
    }
    /**
     * 雨量情報をチェックし
     * 更新されていた場合に、雨量レイヤを書き換える
     */
    checkUpdateLayer() {
        let result = false;
        //  更新時刻の取得
        getTextFile(config.updUinfoUrl, false, (updateTime) => {
            if (!oldUpdatetimes.uinfo || updateTime > oldUpdatetimes.uinfo) {
                if (!util.isSp) {
                    this.setTimeLabel(updateTime);
                }
                this.dispUryoLayer();
                oldUpdatetimes.uinfo = updateTime;
                result = true;
            }
        });
        return result;
    }
    /**
     * 雨量分布図の時刻ラベルの表示（PC版のみ）
     * @param value
     */
    setTimeLabel(value) {
        var year = (value.substr(0, 4));
        var month = (value.substr(4, 2));
        var day = (value.substr(6, 2));
        var hour = (value.substr(8, 2));
        var min = (value.substr(10, 2));
        var dt = new Date(parseInt(year), parseInt(month), parseInt(day), parseInt(hour), parseInt(min));
        //  １時間前の時間を計算
        var dtFrom = new Date(dt);
        dtFrom.setHours(dt.getHours() - 1);
        var hourFrom = ("0" + dtFrom.getHours()).slice(-2);
        var timelabel = dosya_1kmesh_env.label.uryo_datetime_label;
        var label = timelabel.replace("{year}", year)
            .replace("{month}", month)
            .replace("{day}", day)
            .replace("{hourFrom}", hourFrom)
            .replace("{hourTo}", hour)
            .replace("{minFrom}", min)
            .replace("{minTo}", min);
        document.getElementById('detail_uryo_timelabel').textContent = label;
    }
    /**
     * 地図に雨量レイヤーを設定
     */
    dispUryoLayer() {
        const json = util.getGeoJson(util.getPath(dosya_1kmesh_env.uryoGeoJson));
        //  表示中のメッシュレイヤーが存在する場合は削除
        if (this._uryoLayer) {
            this.Map.removeLayer(this._uryoLayer);
        }
        //  雨量Configデータの取得
        map_uryo._uryoConfig = getCsv(config.uryoConfigUrl);
        //  雨量CSVデータの取得
        map_uryo._uryoCsv = getCsv(config.uinfoUrl);
        //  雨量レイヤ生成
        this._uryoLayer = this.createLayer(json);
        //  地図にメッシュレイヤー追加
        this.Map.addLayer(this._uryoLayer);
    }
    /**
     * 雨量レイヤの描画
     * @param json
     */
    createLayer(geoJson) {
        let self = this;
        return L.geoJSON(geoJson, {
            onEachFeature: (featureData, featureLayer) => {
                // 雨量ポイント押下時イベント
                featureLayer.on('click', () => {
                    self.onUryoPointClick(featureData.properties.code);
                });
                // ツールチップ設定（PC版のみ）
                if (!map_uryo._isSp) {
                    this.setToolTip(featureData, featureLayer);
                }
            },
            pointToLayer: (featureData, latlng) => {
                var ui = csvDef.uinfo;
                for (let i = ui.headerRow; i < map_uryo._uryoCsv.length - ui.footerRow; i++) {
                    var row = map_uryo._uryoCsv[i];
                    const uryoPoint = featureData.properties.code;
                    if (uryoPoint === row[ui.colCcd]) {
                        if (map_uryo._isSp && config.LabeledMakerZoomLevel <= self.Map.getZoom()) {
                            // ラベル付きマーカーを表示
                            return L.marker(latlng, {
                                icon: createLabeledMarker(getUryoIconUrl(parseInt(row[ui.colUryo60Min], 10), parseInt(row[ui.colUryo10Min], 10), true), getUryoPointName(map_uryo._uryoConfig, uryoPoint))
                            });
                        }
                        else {
                            return L.marker(latlng, { icon: L.icon({ iconUrl: getUryoIconUrl(row[ui.colUryo60Min], row[ui.colUryo10Min], true), iconSize: [15, 15] }) });
                        }
                    }
                }
                return L.marker(latlng);
            },
        });
    }
    /**
     * ツールチップの設定
     * @param featureData
     * @param featureLayer
     */
    setToolTip(featureData, featureLayer) {
        var tip = '';
        tip += getUryoPointName(map_uryo._uryoConfig, featureData.properties.code);
        var ui = csvDef.uinfo;
        for (let i = ui.headerRow; i < map_uryo._uryoCsv.length - ui.footerRow; i++) {
            let row = map_uryo._uryoCsv[i];
            if (featureData.properties.code == row[ui.colCcd]) {
                tip += '[ ' + row[ui.colUryo60Min] + 'mm/h]';
                tip += '[ ' + dosya_1kmesh_env.label.ruiseki_uryo + ' ' + row[ui.colUryoRuiseki] + 'mm]';
                break;
            }
        }
        featureLayer.bindTooltip(tip, {
            offset: markerTooltipOffset,
            direction: 'right',
            sticky: true
        });
    }
    /**
     * マーカーのセット
     * @param latlng
     */
    setMaker(latlng) {
        if (latlng) {
            if (this._preSelect) {
                this._preSelect.remove();
            }
            this._preSelect = L.marker(latlng).addTo(this.Map);
        }
    }
}
map_uryo._isSp = false;
